import { initNav } from "./nav.js";
import { initPartials, initHead } from "./partials.js";
import { initCarousel } from "./carousel.js";
import { initTabs } from "./tabs.js";
import { initRevealAnimations } from "./reveal.js";

// Initialize head partial first (loads common head content and sets title)
initHead().then(() => {
  // Load other partials, then initialize navigation and carousel
  return initPartials();
}).then(() => {
  initNav();
  // Initialize carousel after a short delay to ensure jQuery/Slick are loaded
  // (they're loaded via CDN in the HTML head)
  if (document.querySelector("[data-carousel]")) {
    // Wait for jQuery and Slick to be available
    const checkDependencies = () => {
      if (typeof window.$ !== 'undefined' && typeof window.$.fn.slick !== 'undefined') {
        initCarousel();
      } else {
        setTimeout(checkDependencies, 50);
      }
    };
    checkDependencies();
  }
  // Initialize tabs (only does anything on pages that have [data-tabs])
  initTabs();
  // Initialize staggered reveal animations for headings, body text, and CTAs
  initRevealAnimations();
});
